export default "__VITE_ASSET__B7fxVtuZ__"